enum actionTypes {
  UPDATE_PRODUCT = 'products/UPDATE_PRODUCT',
  ADD_PRODUCTS = 'products/ADD_PRODUCTS',
  UPDATE_PRODUCTS = 'products/UPDATE_PRODUCTS',
  SET_PRODUCTS = 'products/SET_PRODUCTS',
  SET_CURRENT_STAGE = 'products/SET_CURRENT_STAGE',
}

export default actionTypes;
